module.exports = __webpack_public_path__ + "img/hr-green-asterisk-18.a91fbc05.png";